/**
 * Estrae la chiave Highcharts `hc-key` (es. it-mi) dalla sigla provincia in indirizzi italiani,
 * tipicamente in coda come "(MI)".
 */
export function extractItalianProvinceHcKey(address: string | undefined | null): string | null {
  if (address == null || !String(address).trim()) return null;
  const s = String(address).trim();
  const paren = s.match(/\(([A-Z]{2})\)\s*$/);
  if (paren) return `it-${paren[1].toLowerCase()}`;
  return null;
}
